// extracted by mini-css-extract-plugin
export default {"button":"Chart_button__+1wBF","title":"Chart_title__yw2yU"};